import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { fetchProfile, fetchDashboardToken, logoutUser } from "services/apiService";
import { toast, ToastContainer } from "react-toastify";
import Footer from "components/footer/Footer";
import routes from "routes";
import logo from "assets/img/scale_lens_logo.png";

export default function DashboardLayout() {
  const [profile, setProfile] = useState<any>(null);
  const [goingToDashboard, setGoingToDashboard] = useState(false);

  useEffect(() => {
    fetchProfile().then(setProfile).catch(() => {});
  }, []);

  const handleGoToDashboard = async () => {
    setGoingToDashboard(true);
    try {
      const { url, token } = await fetchDashboardToken();
      window.open(`${url}?token=${token}`, "_blank", "noopener,noreferrer");
      setGoingToDashboard(false);
    } catch (err: any) {
      const status = err.response?.status;
      if (status === 402) {
        toast.error("No active subscription. Please purchase a plan first.");
      } else if (status === 404) {
        toast.info("Your dashboard is being set up. You'll receive access shortly.");
      } else {
        toast.error("Could not load dashboard. Please try again.");
      }
      setGoingToDashboard(false);
    }
  };

  const handleLogout = () => {
    logoutUser();
    window.location.href = "/auth/signin";
  };

  const getRoutes = (routes: RoutesType[]) =>
    routes.map((prop, key) =>
      prop.layout === "/dashboard" ? (
        <Route path={`/${prop.path}`} element={prop.component} key={key} />
      ) : null
    );

  return (
    <div className="min-h-screen flex flex-col bg-[#F7F9FC] font-poppins">

      {/* ── Header ─────────────────────────────────────────────── */}
      <header className="sticky top-0 z-50 bg-white border-b border-[#E4E7EB]">
        <div className="max-w-5xl mx-auto px-6 h-[60px] flex items-center justify-between">
          <img src={logo} alt="ScaleLens" className="h-7 w-auto" />

          <div className="flex items-center gap-3">
            {profile && (
              <span className="hidden sm:block text-sm font-medium text-[#374151]">
                {profile.full_name || profile.email}
              </span>
            )}

            {profile?.is_subscribed && (
              <button
                onClick={handleGoToDashboard}
                disabled={goingToDashboard}
                className="text-sm font-semibold bg-brand-500 text-white px-4 py-[7px] rounded-md hover:bg-brand-600 transition-colors disabled:opacity-60"
              >
                {goingToDashboard ? "Loading…" : "Go to Dashboard →"}
              </button>
            )}

            <button
              onClick={handleLogout}
              className="text-sm font-medium text-[#374151] border border-[#E4E7EB] px-4 py-[7px] rounded-md hover:bg-brand-50 hover:text-brand-600 hover:border-brand-300 transition-colors"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      {/* ── Main content ────────────────────────────────────────── */}
      <main className="flex-1 max-w-5xl mx-auto w-full px-6 py-8">
        <Routes>
          {getRoutes(routes)}
          <Route path="/" element={<Navigate to="/dashboard/profile" replace />} />
          <Route path="*" element={<Navigate to="/dashboard/profile" replace />} />
        </Routes>
      </main>

      {/* ── Footer ─────────────────────────────────────────────── */}
      <Footer />

      <ToastContainer position="top-right" />
    </div>
  );
}
